import { cond } from "@terra-ui-packages/core-utils";
import _ from "lodash/fp.js";
import { forwardRef, useState, createElement } from "react";
import { injectStyle } from "./injectStyle.js";
injectStyle(`
.terra-ui--interactive:hover, .terra-ui--interactive:focus {
  --hover-background: var(--app-hover-background);
  --hover-backgroundColor: var(--app-hover-backgroundColor);
  --hover-border: var(--app-hover-border);
  --hover-color: var(--app-hover-color);
  --hover-boxShadow: var(--app-hover-boxShadow);
  --hover-opacity: var(--app-hover-opacity);
  --hover-textDecoration: var(--app-hover-textDecoration);
}

.terra-ui--interactive:hover .terra-ui--interactive:not(:hover) {
  --hover-background: initial;
  --hover-backgroundColor: initial;
  --hover-border: initial;
  --hover-color: initial;
  --hover-boxShadow: initial;
  --hover-opacity: initial;
  --hover-textDecoration: initial;
}
`);
const pointerTags = ["button", "area", "a", "select"];
const pointerTypes = ["radio", "checkbox", "submit", "button"];
const Interactive = forwardRef((props, ref) => {
  const { children, className = "", disabled, hover = {}, role, style = {}, tabIndex, tagName: TagName = "div", type, onBlur, onClick, onKeyDown, onMouseDown, ...otherProps } = props;
  const [outline, setOutline] = useState();
  const { cursor } = style;
  const computedCursor = cond([!!cursor, () => cursor], [!!disabled, () => "not-allowed"], [!!onClick || pointerTags.includes(TagName) || pointerTypes.includes(type), () => "pointer"]);
  const computedTabIndex = cond([_.isNumber(tabIndex), () => tabIndex], [!!disabled, () => -1], [!!onClick, () => 0], () => void 0);
  const computedRole = cond([!!role, () => role], [!!onClick && !["input", ...pointerTags].includes(TagName), () => "button"], () => void 0);
  const cssVariables = _.flow(_.toPairs, _.flatMap(([key, value]) => {
    return [
      [`--app-hover-${key}`, value],
      [key, `var(--hover-${key}, ${style[key]})`]
    ];
  }), _.fromPairs)(hover);
  return createElement(TagName, {
    ref,
    className: `terra-ui--interactive ${className}`,
    style: {
      ...style,
      ...cssVariables,
      fill: `var(--hover-color, ${style.color})`,
      cursor: computedCursor,
      outline
    },
    role: computedRole,
    tabIndex: computedTabIndex,
    onClick,
    disabled,
    onMouseDown: (e) => {
      setOutline("none");
      onMouseDown == null ? void 0 : onMouseDown(e);
    },
    onBlur: (e) => {
      if (outline) {
        setOutline(void 0);
      }
      onBlur == null ? void 0 : onBlur(e);
    },
    onKeyDown: onKeyDown || ((event) => {
      if (event.key === "Enter") {
        event.stopPropagation();
        event.target.click();
      }
    }),
    ...otherProps
  }, [children]);
});
export {
  Interactive
};
